export const FileOrImageDetector = (base64) => {
  const header = base64.substring(0, base64.indexOf(","));
  if (header.startsWith("data:image")) {
    return true;
  }
  return false;
};
